<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item label="" style="width: 100px">
              <el-select v-model="listMenuForm.block" placeholder="请选择" style="width: 100px !important;">
                <el-option label="會員賬號" value="1"></el-option>
                <el-option label="暱稱" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="listMenuForm.nickName"
                placeholder="請輸入搜索內容"
              ></el-input>
            </el-form-item>
            <el-form-item label="狀態">
              <el-select v-model="listMenuForm.status" @change="changeSelectValue" placeholder="请选择">
                <el-option label="全部" value="null"></el-option>
                <el-option label="已違規" value="3"></el-option>
                <el-option label="待審核" value="2"></el-option>
                <el-option label="已解禁" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchForm hidden-xl-only">
            <el-form-item label="狀態">
              <el-select v-model="listMenuForm.status" @change="changeSelectValue" placeholder="请选择">
                <el-option label="全部" value="null"></el-option>
                <el-option label="已違規" value="3"></el-option>
                <el-option label="待審核" value="2"></el-option>
                <el-option label="已解禁" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row> -->
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">查詢</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table height='660px' stripe :data="complainantList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            label="新闻名称"
            width="190">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="用戶昵稱"
            width="140">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.nickName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="用戶賬號"
            width="190">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="評論時間"
            width="160">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.commentTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="評論內容"
            width="200">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.content }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投訴類型"
            width="140">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.complainsType }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投訴人"
            width="140">
            <template slot-scope="scope">
              <div>
                <el-popover trigger="hover" placement="top" v-if="scope.row.hoverText">
                  <p>{{ scope.row.hoverText }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span style="margin-left: 10px">{{ scope.row.list }}</span>
                  </div>
                </el-popover>
                <span v-else style="margin-left: 10px">{{ scope.row.list }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="投訴次數"
            width="70">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.complainsCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="狀態"
            width="70">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.complainsStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="投訴時間"
            width="160">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.complainsTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <div v-if="scope.row.complainsStatus==='待審核'">
                <span style="color: #6c3dea; cursor:pointer;" @click="dealComment(scope.row.id,3)" type="text">違規</span>
                <span style="color: #6c3dea; cursor:pointer;" @click="dealComment(scope.row.id,4)" type="text">解禁</span>
              </div>
              <div v-else-if="scope.row.complainsStatus==='已違規'">
                <span style="color:grey;cursor:auto;" type="text">違規</span>
                <span style="color: #6c3dea; cursor:pointer;" @click="dealComment(scope.row.id,4)" type="text">解禁</span>
              </div>
              <div v-else>
                <span style="color: #6c3dea; cursor:pointer" @click="dealComment(scope.row.id,3)" type="text">違規</span>
                <span style="color:grey;cursor:auto;" type="text">解禁</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
                       hide-on-single-page
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-size="10"
                       :pager-count='5'
                       layout="prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data() {
    return {
      navBlock: '靈魂的共鳴',
      navtitle: '評論投訴',
      listMenuForm: {
        block: '1',
        nickName: '',
        status: '2'
      },
      complainantList: [],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
    }
  },
  created() {
    let _this = this;
    _this.getCommentComplaintList();
  },
  activated() {
    let _this = this;
    if (_this.currentPage === 1
      && _this.listMenuForm.nickName === ''
      && (_this.listMenuForm.status == 0 || _this.listMenuForm.status == null)) {
      _this.getCommentComplaintList();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    getCommentComplaintList() {
      let _this = this;
      console.log(_this.listMenuForm.block == '1')
      console.log(_this.listMenuForm.nickName)
      let param = {
        nickName: _this.listMenuForm.block == '2' ? _this.listMenuForm.nickName : '',
        userName: _this.listMenuForm.block == '1' ? _this.listMenuForm.nickName : '',
        status: _this.listMenuForm.status == null ? null : Number(_this.listMenuForm.status),
        pageNo: _this.currentPage,
        pageSize: 10
      }
      _this.$post(`/request/complains/soul/resonance`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v => {
              v.commentTime = _this.$getTime(v.commentTime)
              v.complainsTime = _this.$getTime(v.complainsTime)
              switch (v.complainsStatus) {
                case 4:
                  v.complainsStatus = '已解禁'
                  break
                case 2:
                  v.complainsStatus = '待審核'
                  break
                case 3:
                  v.complainsStatus = '已違規'
                  break
              }

              switch (v.complainsType) {
                case 1:
                  v.complainsType = '仇恨言論或人身攻擊'
                  break
                case 2:
                  v.complainsType = '垃圾或廣告訊息'
                  break
                case 3:
                  v.complainsType = '詐騙或不實信息'
                  break
                case 4:
                  v.complainsType = '色情訊息'
                  break
                case 5:
                  v.complainsType = '有害或危險內容'
                  break
                case 6:
                  v.complainsType = '其他'
                  break
              }
              _this.total = res.data.allRow
              if (v.list) {
                let complainsUser = []
                for (let i in v.list) {
                  complainsUser.push(v.list[i].nickname)
                }
                if (complainsUser.length > 3) {
                  v.hoverText = complainsUser.toString()
                  v.list = `${complainsUser[0]},${complainsUser[1]},${complainsUser[2]}等多位用戶`;
                } else {
                  v.list = complainsUser.toString();
                }

              }
            });
            _this.complainantList = res.data.list
          } else {
            _this.$propMessage(res.message, 'error');
          }
        });
    },

    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCommentComplaintList();
    },
    changeSelectValue(val) {
      let _this = this;
      _this.listMenuForm.status = val == 0 ? null : val
    },
    // 搜索评论
    search() {
      let _this = this;
      if (_this.listMenuForm.block === '' && _this.listMenuForm.nickName === '' && _this.listMenuForm.status === null) {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入至少一個搜索條件', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.listMenuForm.block === '' && _this.listMenuForm.nickName) {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇搜索類型', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.currentPage = 1;
      _this.getCommentComplaintList();
    },

    // 違規審核
    dealComment(id, flag) {
      let _this = this;
      _this.$put(`/request/complains/soul/resonance?feedbackId=${id}&complainsStatus=${flag}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === '00000') {
            _this.$propMessage('審核成功', 'success',
              function () {
                _this.dialogVisible = false;
                _this.currentPage = 1
                _this.getCommentComplaintList();
              })

          } else {
            _this.$propMessage(res.message, 'error',
              function () {
                _this.dialogVisible = false;
              });
          }
        });
    },
    reset() {
      let _this = this;
      _this.listMenuForm = {
        block: '',
        nickName: '',
        status: null
      }
      _this.currentPage = 1;
      _this.getCommentComplaintList();
    },

  },
  components: {
    NavBar,
    DiaMess,

  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    @media (max-width: 768px) {
      height: calc(100% - 62px);
    }

    .addBtn {
      margin: 0.2rem 0;
      cursor: pointer;

      @media (max-width: 420px) {
        margin-top: 0.3rem;
        margin-bottom: 10px;
      }

    }

    .btn {
      @media (max-width: 420px) {
        width: 1.3rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 12px;
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }

    }

    .el-table {
      @media (max-width: 420px) {
        min-width: 200%;
      }
    }

  }

  .paging-block {
    margin: 0.2rem 0;

    @media (max-width: 420px) {
      margin: 0.3rem 0;
    }

  }

  .label_num {
    font-size: 14px;
    line-height: 32px;
  }

  @media screen and (min-width: 769px) {
    .ListMenu {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      .searchForm {
        flex: 1;
        display: flex;
        justify-content: flex-start;
      }

      .MenuBtnWrap {
        flex: 1;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/jjsoul/collectionComplain.vue